/**
 * Mask a phone number for display, showing only the last 4 digits.
 * e.g. "+15551234567" → "(•••) •••-4567"
 */
export function maskPhoneNumber(phone: string): string {
	const digits = phone.replace(/\D/g, '');
	if (digits.length < 4) {
		return '•'.repeat(digits.length);
	}
	const last4 = digits.slice(-4);
	return `(•••) •••-${last4}`;
}
